// packages import
import { createContext, FC, Reducer, useMemo, useReducer } from 'react'

// others
import { EntryAction, entryInitialState, entryReducer, EntryState } from '../components/entries/EntryReducer'
import { ChildrenType } from '../interfaceTypes'

export interface EntryContextType extends EntryState {
  dispatch: React.Dispatch<EntryAction>
}

export const EntryContext = createContext<EntryContextType>({
  ...entryInitialState,
  dispatch: () => {
    return
  }
})

export const EntryContextProvider: FC<ChildrenType> = ({ children }): JSX.Element => {
  const [state, dispatch] = useReducer<Reducer<EntryState, EntryAction>>(entryReducer, entryInitialState)

  const contextValue = useMemo(
    () => ({
      ...state,
      dispatch
    }),
    [state]
  )

  return <EntryContext.Provider value={contextValue}>{children}</EntryContext.Provider>
}
